/**
 * RecordStart – SVG icon.
 */
import Props from '@shared/types/props/pressable';
import Colors from '@shared/assets/style/default/color';
import Screen from '@screen';

/** Start recording indicator. */
export default function RecordStartIcon({ focused }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${32 * Screen.widthRatio}`}
      height={`${32 * Screen.widthRatio}`}
      viewBox={'0 0 32 32'}
    >
      <path
        d='M16 3.11532e-06C24.8366 2.72906e-06 32 7.16345 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 -3.13124e-07 24.8366 -6.99382e-07 16C-1.08564e-06 7.16345 7.16344 3.50157e-06 16 3.11532e-06ZM16 29.3159C23.3542 29.3159 29.3159 23.3542 29.3159 16C29.3159 8.64584 23.3542 2.68412 16 2.68412C8.64584 2.68412 2.68412 8.64584 2.68412 16C2.68412 23.3542 8.64584 29.3159 16 29.3159Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M23.4275 16C23.4275 20.1027 20.1016 23.4286 15.9989 23.4286C11.8962 23.4286 8.57031 20.1027 8.57031 16C8.57031 11.8973 11.8962 8.57141 15.9989 8.57141C20.1016 8.57141 23.4275 11.8973 23.4275 16Z'
        fill='#D20000'
      />
    </svg>
  );
}
